import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ListAltIcon from '@mui/icons-material/ListAlt';
import {Box, Tab, Tabs} from '@mui/material';
import React, {useState} from 'react';
import {i18n} from 'src/i18n';
import GestorDocumentalListFilter from 'src/view/gestorDocumental/list/GestorDocumentalListFilter';
import GestorDocumentalListTable from 'src/view/gestorDocumental/list/GestorDocumentalListTable';
import GestorDocumentalListToolbar from 'src/view/gestorDocumental/list/GestorDocumentalListToolbar';
import DocumentosArbolView from 'src/view/gestorDocumental/view/DocumentosArbolView';
import ContentWrapper from 'src/view/layout/styles/ContentWrapper';
import Breadcrumb from 'src/view/shared/Breadcrumb';
import PageTitle from 'src/view/shared/styles/PageTitle';
import GestorDocumentalListTableDrawer from './GestorDocumentalListTableDrawer';

function GestorDocumentalListPage(props) {
  // Estado para controlar la pestaña activa: 0 = Vista de tabla, 1 = Vista de árbol
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Componente para mostrar el contenido de la pestaña
  const TabPanel = (props) => {
    const {children, value, index, ...other} = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`documentos-tabpanel-${index}`}
        aria-labelledby={`documentos-tab-${index}`}
        style={{width: '100%'}}
        {...other}>
        {value === index && <Box sx={{pt: 2}}>{children}</Box>}
      </div>
    );
  };

  return (
    <>
      {!props.drawer && <Breadcrumb items={[[i18n('dashboard.menu'), '/'], [i18n('entities.gestorDocumental.menu')]]} />}

      <ContentWrapper>
        <PageTitle>{i18n('entities.gestorDocumental.list.title')}</PageTitle>
        <GestorDocumentalListToolbar />

        {/* No mostrar pestañas en modo drawer */}
        {!props.drawer ? (
          <>
            <GestorDocumentalListFilter />

            {/* Pestañas para alternar entre la vista de tabla y la vista de árbol */}
            <Box sx={{borderBottom: 1, borderColor: 'divider', mt: 2}}>
              <Tabs value={activeTab} onChange={handleTabChange} aria-label="vistas de documentos">
                <Tab
                  icon={<ListAltIcon />}
                  label={i18n('entities.gestorDocumental.view.vistaTabla')}
                  id="documentos-tab-0"
                  aria-controls="documentos-tabpanel-0"
                />
                <Tab
                  icon={<AccountTreeIcon />}
                  label={i18n('entities.gestorDocumental.view.vistaArbol')}
                  id="documentos-tab-1"
                  aria-controls="documentos-tabpanel-1"
                />
              </Tabs>
            </Box>

            {/* Panel para vista de tabla */}
            <TabPanel value={activeTab} index={0}>
              <GestorDocumentalListTable />
            </TabPanel>

            {/* Panel para vista de árbol */}
            <TabPanel value={activeTab} index={1}>
              <DocumentosArbolView />
            </TabPanel>
          </>
        ) : (
          <>
            <h3>Seleccione sus elementos:</h3>
            <hr></hr>
            <GestorDocumentalListTableDrawer {...props} />
          </>
        )}
      </ContentWrapper>
    </>
  );
}

export default GestorDocumentalListPage;
